import { SaveButton } from "components/Buttons"
import React, { useState } from "react"
import { connect } from "react-redux"
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import { hidePwdSecurityCheckModal, pwdSecurityCheck } from "store/actions"

const PwdSecurityCheckModal = ({
  pwdSecurityCheckLoading,
  pwdSecurityCheck,
  hidePwdSecurityCheckModal,
}) => {
  const [passwordValue, setPasswordValue] = useState("")
  return (
    <React.Fragment>
      <Row>
        <Col>
          <h6>
            In order to change a User’s Password, you must first re-enter your
            Admin Password.
          </h6>
        </Col>
      </Row>
      <Form
        className="my-2"
        onSubmit={(event) => {
          event.preventDefault()
          if (!!passwordValue || passwordValue?.trim()?.length > 0) {
            pwdSecurityCheck({ password: passwordValue })
          }
        }}
      >
        <FormGroup row>
          <Label for="pwd" xs="auto">
            Password
          </Label>
          <Col>
            <Input
              id="pwd"
              value={passwordValue}
              onChange={event => {
                setPasswordValue(event.target.value)
              }}
              placeholder="Password"
              type="password"
            />
          </Col>
        </FormGroup>
      </Form>
      <Row className="d-flex justify-content-end mt-3">
        <Col xs="auto">
          <SaveButton
            content="Cancel"
            type="button"
            onClick={hidePwdSecurityCheckModal}
            color="danger"
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            content="Next"
            type="submit"
            onClick={() => {
              pwdSecurityCheck({ password: passwordValue })
            }}
            loading={pwdSecurityCheckLoading}
            disabled={!passwordValue || passwordValue?.trim()?.length === 0}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  pwdSecurityCheckLoading: state.Profile.pwdSecurityCheckLoading,
})

const mapDispatchToProps = dispatch => ({
  hidePwdSecurityCheckModal: () => dispatch(hidePwdSecurityCheckModal()),
  pwdSecurityCheck: values => dispatch(pwdSecurityCheck(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PwdSecurityCheckModal)
